import React, { useState } from 'react';
import axios from 'axios';
import { CircleChevronRight } from 'lucide-react';
const CallbackBar = (props) => {
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (!/^\d{10}$/.test(mobile)) {
    //         alert('Please enter a valid 10-digit mobile number.');
    //         return;
    //     }

    //     try {
    //         setLoading(true);
    //         await axios.post('https://aerie-academy-backend.vercel.app/api/contact', { phone: mobile, name: 'Callback Lead', email: 'callback@noemail.com', }, { headers: { 'Content-Type': 'application/json' } });
    //         setSuccessMsg('Thank you! Our advisor will call you shortly.');
    //         setMobile('');
    //     } catch (error) {
    //         console.error('Error submitting number:', error);
    //         alert('Something went wrong. Please try again later.');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return (
        <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 w-[90%] sm:w-[80%] bg-gradient-to-r from-[#002D72] via-[#0066CC] to-[#00A3FF] shadow-xl z-50 text-white py-4 px-6 rounded-tl-2xl rounded-tr-2xl">
            <div className="max-w-5xl mx-auto flex flex-row items-center justify-center gap-3 text-center">
                {/* CTA Button */}
                <button
                    onClick={props.openModal}
                    className="flex items-center gap-2 px-6 sm:px-6 py-2 sm:py-2 
         text-sm sm:text-base md:text-lg 
         text-white bg-emerald-500 hover:bg-emerald-600 
         font-semibold rounded-full transition duration-300 shadow-md"
                >
                    BOOK FREE DEMO
                    <CircleChevronRight className="w-5 h-5" />
                </button>

                <a
                    href="https://wa.me/919980933490"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 
         text-sm sm:text-base md:text-lg 
         text-white 
         font-semibold rounded-full transition duration-300 shadow-md"
                >
                    <img src="\what'saap.png" alt="" className='w-11 h-11 rounded-full bg-emerald-300 hover:bg-emerald-400 ' />
                </a>

                {/* Success Message */}
                {successMsg && (
                    <p className="text-sm mt-1 text-white font-medium">
                        {successMsg}
                    </p>
                )}
            </div>
        </div>
    );
};

export default CallbackBar;
